import { prefecturesReducer } from "../../../../components/PrefecturesSelector/functions/prefecturesReducer";
import { getToggleCategoryItemChecked } from "./functions/getToggleCategoryItemChecked";

import type { Action as PrefectureAction } from "../../../../components/PrefecturesSelector/functions/prefecturesReducer";
import type { Action } from "../../types/actions";
import type { CommonConditionsState, State } from "../../types/states";
import type { Reducer } from "redux";

const COMMON_CONDITIONS_ITEM_INITIAL_STATE: CommonConditionsState = {
  categoryLabel: "",
  checkboxData: [],
};

const INITIAL_STATE: State = {
  availabilityStatus: COMMON_CONDITIONS_ITEM_INITIAL_STATE,
  endDate: undefined,
  eventType: COMMON_CONDITIONS_ITEM_INITIAL_STATE,
  genre: COMMON_CONDITIONS_ITEM_INITIAL_STATE,
  prefectures: [],
  startDate: undefined,
};

export const formStateReducer: Reducer<State, Action> = (
  state = INITIAL_STATE,
  action
) => {
  const { availabilityStatus, eventType, genre, prefectures } = state;
  const { type } = action;

  switch (type) {
    case "startDate": {
      const { newDate } = action;
      return { ...state, startDate: newDate };
    }
    case "endDate": {
      const { newDate } = action;
      return { ...state, endDate: newDate };
    }
    case "eventType/checkbox": {
      const { checkboxData } = eventType;
      const toggleCategoryItemChecked = getToggleCategoryItemChecked(
        action.checkboxId
      );
      return {
        ...state,
        eventType: {
          ...eventType,
          checkboxData: checkboxData.map(toggleCategoryItemChecked),
        },
      };
    }
    case "genre/checkbox": {
      const { checkboxData } = genre;
      const toggleCategoryItemChecked = getToggleCategoryItemChecked(
        action.checkboxId
      );
      return {
        ...state,
        genre: {
          ...genre,
          checkboxData: checkboxData.map(toggleCategoryItemChecked),
        },
      };
    }
    case "availabilityStatus/checkbox": {
      const { checkboxData } = availabilityStatus;
      const toggleCategoryItemChecked = getToggleCategoryItemChecked(
        action.checkboxId
      );
      return {
        ...state,
        availabilityStatus: {
          ...availabilityStatus,
          checkboxData: checkboxData.map(toggleCategoryItemChecked),
        },
      };
    }
    case "prefectures/collapse": {
      const thisAction: PrefectureAction = {
        ...action,
        type: "collapse",
      };
      return {
        ...state,
        prefectures: prefecturesReducer(prefectures, thisAction),
      };
    }
    case "prefectures/checkbox": {
      const thisAction: PrefectureAction = {
        ...action,
        type: "checkbox",
      };
      return {
        ...state,
        prefectures: prefecturesReducer(prefectures, thisAction),
      };
    }
    default: {
      return state;
    }
  }
};
